<template>
    <div>
        <Loading :isLoading="saveLoading" />
        <Upload :action="uploadImgUrl" :format="['pdf']" accept='.pdf' :on-format-error="uploadError"
            :data="uploadData"
            :max-size="maxImgSize" :on-exceeded-size="checkImgSize" :on-success="quillImgSuccess"
            :on-error="quillImagError"
            :show-upload-list="false" :before-upload="quillImgBefore" style="display: none;">
            <Button ref="imgUploadPdfBtn" style="display: none;"></Button>
        </Upload>
        <div>
            <!-- 富文本组件 -->
            <quill-editor class="editor" v-model="content" :ref="toref" :options="editorOption"
                :style="{height:qillHeight+'px'}" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                @change="onEditorChange($event)"></quill-editor>
        </div>
        <!-- <div>
            <button @click="showText" style="margin-top: 100px;">打印文字</button>

        </div> -->
        <Button type="primary" ref="UploadPdfBtn" @click="showPdfModel" style="display: none;">上传pdf</Button>
        <Modal v-model="addPdfmodal" title="上传Pdf">
            <label>pdf名称</label><br />
            <Input v-model="pdfFormName" placeholder="请输入pdf名称..." />
            <div slot="footer">
                <button @click="uploadPdf">上传</button>
            </div>
        </Modal>
    </div>

</template>
<script>
// 工具栏配置
const toolbarOptions = [
    // ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
    // ["blockquote", "code-block"],                    // 引用  代码块
    // [{ list: "ordered" }, { list: "bullet" }],       // 有序、无序列表
    // [{ indent: "-1" }, { indent: "+1" }],            // 缩进
    //  [{ size: ["small", false, "large", "huge"] }],   // 字体大小
    //   [{ header: [1, 2, 3, 4, 5, 6, false] }],         // 标题
    // [{ color: [] }, { background: [] }],             // 字体颜色、字体背景颜色
    // [{ align: [] }],                                 // 对齐方式
    ["clean"],                                       // 清除文本格式
    ["link", "image"]                       // 链接、图片、视频
];

import { quillEditor } from "vue-quill-editor";
import Quill from 'quill';
const Delta = Quill.import('delta');

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Loading from '@/components/loading/Loading.vue';
import { UPLOAD_FILE_API, UPLOAD_FILE_API_PATH, FILE_SERVER, DOWNLOAD_SERVER } from '@/api/modules/files';


export default {
    name: 'quill-editor-upload',
    props: {
        /* 编辑器的内容 */
        value: {
            type: String
        },
        /* 图片大小 */
        maxImgSize: {
            type: Number,
            default: 400000 //kb
        },
        uploadData:{
            type:Object,
            default:function (){
                return { updatePath:"" };
            }
        },
        uploadImgUrl: {
            type: String,
            default: UPLOAD_FILE_API_PATH// 上传的图片服务器地址
        },
        qillHeight:{
            type: Number,
            default: 400 //kb
        },
        productUuid:{
            type: String, 
            default:""
        },
        imgServer:{
            type: String,  // 获取图片的服务器地址     
            default:DOWNLOAD_SERVER// 上传的图片服务器地址  
        },
        toref: {
            type: String,
            default: "quillEditor"
        }
    },
    components: { quillEditor, Loading },
    data() {
        return {
            saveLoading:false,
            addPdfmodal: false,
            pdfFormName: '',
            content: this.value,
            // uploadData:{updatePath:'productPdf'},
            editorOption: {
                theme: "snow", // or 'bubble'
                placeholder: "请输入内容",
                modules: {
                    toolbar: {
                        container: toolbarOptions,
                        handlers: {
                            image: (value) => {
                           
                            //    this.getRange();
                                this.$refs.UploadPdfBtn.$el.click();
                            }
                        }
                    }
                }
            }      
     
        };
    },
    watch: {
        value: function () {
            this.content = this.value;
        }     
    },
    // computed: {
    //     uploadData:function(){  
    //         let  uploadData={};
    //         if(this.productUuid){
    //             uploadData.updatePath='productDesInfoPdfLinkList/'+this.productUuid;
    //         }
    //         else{
    //             uploadData.updatePath='productDesInfoPdfLinkList';
    //         }
    //         return uploadData;
    //     }
    // },
    methods: {
        onEditorBlur() {
            //失去焦点事件
        },
        onEditorFocus() {
            //获得焦点事件
        },
        onEditorChange() {
            //内容改变事件
            this.$emit("input", this.content);
        },
        // getRange(){      
        //     let toeval = "this.$refs." + this.toref + ".quill"    
        //     let quill = eval(toeval);
        //     this.quillRange = quill.getSelection()
        // },
        quillImgBefore(file) {
            let fileType = file.type;
            if (fileType === 'application/pdf') {
                this.saveLoading=true;
                return true;
            }
            else {
                this.$Message.error('请插入图片类型文件(pdf)');
                return false;
            }
            
            
            
        },
        quillImagError(error){
            this.saveLoading=false;            
            this.$Message.error("pdf上传失败");
        },

        quillImgSuccess(res, file) {         
            // res为图片服务器返回的数据
            // 获取富文本组件实例
            let toeval = "this.$refs." + this.toref + ".quill";          
            let quill = eval(toeval);
    
            // 如果上传成功
            if (res.code == 0) {
                // 获取光标所在位置
                let index = quill.selection.savedRange.index;
                // 插入图片  res.url为服务器返回的图片地址
                let length=quill.selection.savedRange.length;           
                // 创建一个 Delta 对象来定义样式
                const imageDelta = new Delta()
                    .retain(index) // 保留插入点之前的内容
                    .insert(
                        this.pdfFormName, { link: this.imgServer + res.data.fileList[0].fileUuid }
                    ).retain(quill.getLength() - index - length);

                //   quill.insertEmbed(length, "image",  'api/storage/upload/'+res.data.fileList[0].fileUuid);
                quill.updateContents(imageDelta);
                // 调整光标到最后
                quill.setSelection(index +this.pdfFormName.length);
                this.saveLoading=false;
            }
            else {
                this.$Message.error("图片插入失败");
                this.saveLoading=false;
            }
        },
        showPdfModel() {
            this.pdfFormName='';
            this.addPdfmodal = true;
        },

        // 富文本图片上传失败
        uploadError(request, file) {
            // loading动画消失
            this.saveLoading=false;
            this.$Message.error("pdf插入失败");
        },
        checkImgSize(file, fileList) {
            this.$Notice.warning({
                title: '图片大小超标',
                desc: `允许上传的最大值是${this.maxImgSize}kb,此图片的大小是${Math.round(file.size / 1024)}kb`
            });

        },
        showText() {
            debugger;
            let quill = this.$refs.quillEditor.quill;
            let range = quill.getSelection();
            // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
            let index = range ? range.index : 0;
            console.log(index);
            console.log('内容：' + this.content);
        },

        uploadPdf() {
            if (!this.pdfFormName) {
                this.$Message.error('pdf名称不能为空');
                return;
            }
            this.addPdfmodal = false;
            this.$refs.imgUploadPdfBtn.$el.click();
        }
    }


};
</script>

<style>
.editor {
    line-height: normal !important;
    height: 192px;
}

.quill-img {
    display: none;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
}



.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";

}

.ql-container {

    font-size: 20px;
}
</style>